var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-inline"},[_c('span',{class:_vm.buttonClasses,attrs:{"title":_vm.canDeleteWorkTime ? 'Löschen' : 'Löschantrag erstellen'},on:{"click":_vm.handleDelete}},[_c('span',{staticClass:"glyphicon glyphicon-trash",attrs:{"aria-hidden":"true"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }